export * from './maxVideoRecordingDuration';
export * from './videoRecordingSettings';

/** Should be used if no endpoint-set value can be retrieved */
export const MAX_NUMBER_RINGS_FALLBACK = 8;
